import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CommunicationService from "Lib/API/Communication/index";
import FinanceSetting from "Lib/API/FinanceSetting/FinanceSetting";
import { ReactComponent as FilterIcon } from "assets/icons/Filter.svg";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import NoDataIcon from 'assets/icons/no-data-class-icon.svg';
import Action from "components/ActionPopOver";
import InfoTooltip from "components/InfoTooltip";
import AlertDialog from "components/Dialog";
import MainModal from "components/MainModal/MainModal";
import MyButton from "components/MyButton/index";
import MyFilterButton from "components/MyFilterButton";
import SearchComp from "components/Searchcomponent";
import EmailEditor from "components/SendLetter/EmailEditor/EmailEditor";
import { Template } from "components/Template/Template";
import Button from "components/button/Button";
import Loader from "components/loader/Loader";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { setFormTemplateCampainPage, setOpenTemplateCreationDialog, setPreviewTemplete } from "services/api/communication";
import {
  ButtonsContainer,
  Content,
  HoverWrapper,
  MenuButton,
  NoContentWrapper,
  SearchWrapper,
  TemplateName,
  Title,
  Wrapper,
} from "./Theme";
import Checkbox from "@mui/material/Checkbox";
import EmailsList from "components/ShareDocuments/Emails/EmailsList";
import { getRandColor } from "components/ShareDocuments/Emails/emailRandomColor";
import { fontConfig } from "theme/fontConfig";

const TemplateCheckbox = React.memo(({ id, selectedTemplates, onSelect }) => {
  return (
    <Checkbox
      checked={selectedTemplates === id}
      onChange={() => onSelect(id)}
      disableRipple
      size="small"
      sx={{
        position: "absolute !important",
        // top: 8,
        // left: 8,
        zIndex: 100,
        backgroundColor: "#fff",
        borderRadius: "4px",
        padding: "2px",
      }}
    />
  );
});
export const Templates = React.memo(({componentCalled,formik}) => {
  const dispatch = useDispatch();
  const [selectedTemplates, setSelectedTemplates] = useState(null);
  const [isHovered, setIsHovered] = useState({ index: null, isHovered: false });
  const [sortBy, setSortBy] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [templatesOptions, setTemplatesOptions] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [page, setPage] = useState(0);
  const [templateList, setTemplateList] = useState([]);
  const [count, setCount] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [templateContent, setTemplateContent] = useState("");
  const [jsonContent, setJsonContent] = useState({});
  const [htmlContent, setHtmlContent] = useState("");
  const [enableEdit, setEnableEdit] = useState(false);
  const [tokenList, setTokenList] = useState([]);
  const [oneTemplateLoading, setOneTemplateLoading] = useState(false);
  const [templateToken, setTemplateToken] = useState([]);
  const [templateDetails, setTemplateDetails] = useState();
  const emailEditorRef = useRef({ projectId: 195575 });
  const [refresh, setRefresh] = useState(false);
  const [alertConfirmation, setAlertConfirmation] = useState(false);
  const [duplicateTemplateName, setDuplicateTemplateName] = useState("");
  const [brokenThumbnails, setBrokenThumbnails] = useState(new Set());
   const accountEmail = JSON.parse(localStorage.getItem("email_address"));
    const [savedEmails, setSavedEmails] = useState(() => {
      const existing = formik?.values?.emailNotification;
      const isFormOrEvent = componentCalled === 'form' || componentCalled === 'event';
      if (existing?.length) {
        const emails = existing.map((email) => ({
          email,
          image: email.charAt(0).toUpperCase(),
          color: getRandColor(),
        }));
        if (!isFormOrEvent && !emails.some((e) => e.email === accountEmail)) {
          emails.unshift({ email: accountEmail, image: accountEmail.charAt(0).toUpperCase(), color: getRandColor() });
        }
        return emails;
      }
      if (isFormOrEvent) return [];
      return [{ email: accountEmail, image: accountEmail.charAt(0).toUpperCase(), color: getRandColor() }];
    });
    
    useEffect(() => {
  if (componentCalled !== "form" && componentCalled !== "event") return;
  if (!templateList?.length) return;

  const fillTitleMap = {
    form: "form filled",
    event: "event registration completed",
  };
  const billTitleMap = {
    form: "form filled using bill my account",
    event: "event registration using bill my account",
  };

  const formFilled = templateList.find(
    (t) => t?.title?.trim().toLowerCase() === fillTitleMap[componentCalled]
  );

  const billMyAccount = templateList.find(
    (t) => t?.title?.trim().toLowerCase() === billTitleMap[componentCalled]
  );

  if (formFilled) {
    formik.setFieldValue("fillTemplate", formFilled._id);
  }

  if (billMyAccount) {
    formik.setFieldValue("billMyAccountTemplate", billMyAccount._id);
  }

}, [templateList, componentCalled]);
//     useEffect(() => {
//   if (componentCalled === "form" && filteredTemplates?.length) {
//     filteredTemplates.forEach((template) => {
//       if (template?.title?.toLowerCase() === "form filled") {
//         formik.setFieldValue("fillTemplate", template._id);
//       } else {
//         formik.setFieldValue("billMyAccountTemplate", template._id);
//       }
//     });
//   }
// }, [filteredTemplates, componentCalled]);
//     useEffect(() => {
//   if (componentCalled === "form" && filteredTemplates?.length) {
//     filteredTemplates.forEach((template) => {
//       if (template?.title?.toLowerCase() === "form filled") {
//         formik?.setFieldValue("fillTemplate", template?._id);
//       } else {
//         formik?.setFieldValue("billMyAccountTemplate", template?._id);
//       }
//     });
//     console.log(formik?.value)
//   }
// }, [filteredTemplates, componentCalled]);
      const addEmailsHandler = ({ type, email }) => {
        if (savedEmails?.some((savedEmail) => savedEmail.email === email)) return;
        setSavedEmails((prev) => [
          ...prev,
          {
            type,
            email,
            image: email.charAt(0).toUpperCase(),
            color: getRandColor(),
          },
        ]);
      };
      const removeEmailHandler = (email) => {
        setSavedEmails((prev) => prev.filter((item) => item.email !== email));
      };

  const [confirmOpen, setConfirmOpen] = useState({
    open: false,
    type: "",
    message: "",
    isLoading: false,
  });
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const {
    openTempleteCreationDialog,
    previewTemplete,
    formTemplateCampainPage,
  } = useSelector((state) => state.communication);
  const [search, setSearch] = useState({
    search: undefined,
  });
  const tokenTypes = {
    yehrzeit: "deceased",
    event: "event",
    form: "form",
    education: "education",
    donation: "donation",
    communication: "communication",
    enrollment: "enrollment",
    invitation: "invitation",
  };
  const useStyles = makeStyles({
    card: {
      borderRadius: "0",
      boxShadow: "none !important",
      height: "100%",
      "&:hover": {
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
      },
      marginTop: 20,
      marginRight: 20,
      paddingLeft: 10,
    },
  });
  const classes = useStyles();

  const handleTemplateSelect = (id) => {
  setSelectedTemplates((prev) => (prev === id ? null : id));

};

  const handleInputChange = (e) => {
    setPage(0);
    const inputValue = e.target.value;
    const regex = /[\\*\(\)\+]/;
    if (!regex.test(inputValue)) {
      setSearchValue(inputValue);
    }
  };

  const getTempleteList = async () => {
    setLoading(true);

    const filterData =   componentCalled === "form" || componentCalled === "event"
    ? {
        search: search?.search,
        filter: {
          type: componentCalled,
          templateSource: "system",
          ...(componentCalled === "event" && formik?.values?.id && { eventId: formik.values.id }),
          ...(componentCalled === "form" && formik?.values?.id && { formId: formik.values.id }),
        },
      }
    :sortBy
      ? {
        search: search?.search,
        filter: {
          type: sortBy,
        },
      }
      : {
        search: search?.search,
      };
    try {
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.getTemplateList(
        token,
        page + 1,
componentCalled==='form' || componentCalled === 'event'?8:12,        // todo make it 8 if from form
        filterData
      );
      setCount(result?.pagination?.count);
      setTemplateList(result?.result);
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    } finally {
      setLoading(false);
      setHasLoaded(true);
    }
  };

  const debounceSearch = useCallback(
    debounce(() => {
      if (search) {
        getTempleteList();
      }
    }, 500),
    [search, sortBy, page, refresh]
  );
  useEffect(() => {
    if (searchValue === "") {
      setSearch({ search: undefined });
    } else {
      setSearch({ search: searchValue });
    }
  }, [searchValue]);
  useEffect(() => {
    if (search) {
      debounceSearch();
    } else {
      getTempleteList();
    }
    return () => debounceSearch.cancel();
  }, [search, sortBy, page, refresh]);

  useEffect(() => {
  if (componentCalled !== "form" && componentCalled !== "event") return;

  const emailIds = savedEmails.map((item) => item.email);

  formik.setFieldValue("emailNotification", emailIds);

}, [savedEmails]);


  const getTemplateTokens = async (type) => {
    const fileType = tokenTypes[type] || "document";
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(token, fileType);
      const tokens = response?.result;
      setTokenList(tokens);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };

  const getTemplateById = async (id) => {
    setOneTemplateLoading(true);
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateById(token, id);
      setTemplateContent(response?.result?.content?.replace(/&lt;/g, "<"));
      getTemplateTokens(response?.result?.type);
      setTemplateToken(response?.result?.tokens);
      setTemplateDetails(response?.result);

      // If this template was already edited in this session, use the saved payload
      let savedPayload = null;
      if (componentCalled === "event" || componentCalled === "form") {
        if (id === formik?.values?.fillTemplate && formik?.values?.fillTemplatePayload) {
          savedPayload = formik.values.fillTemplatePayload;
        } else if (id === formik?.values?.billMyAccountTemplate && formik?.values?.billMyAccountTemplatePayload) {
          savedPayload = formik.values.billMyAccountTemplatePayload;
        }
      }

      setHtmlContent(savedPayload?.htmlContent ?? response?.result?.htmlContent);
      setJsonContent(savedPayload?.jsonContent ?? response?.result?.jsonContent);
      dispatch(setFormTemplateCampainPage({}));
      dispatch(setPreviewTemplete(true));
      dispatch(setOpenTemplateCreationDialog(true));

    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
    setOneTemplateLoading(false);
  };

  const createNewTemplate = ({ template, newTemplate }) => {
    dispatch(setOpenTemplateCreationDialog(false));
    dispatch(setFormTemplateCampainPage({}));
    if (!newTemplate) {
      setTemplates((prev) => [...prev, template]);
      setTemplatesOptions((prev) => [
        ...prev,
        {
          label: template?.title,
          value: template?._id,
        },
      ]);
      return;
    }
  };
  const handleDuplicateEditSave = (data) => {
    if (!formik) return;
    if (templateDetails?._id === formik?.values?.fillTemplate) {
      formik.setFieldValue("fillTemplatePayload", data);
    } else if (templateDetails?._id === formik?.values?.billMyAccountTemplate) {
      formik.setFieldValue("billMyAccountTemplatePayload", data);
    }
    toastr.success("Success", "Template saved");
  };

  const onTemplateClickHandler = (template, type) => {
    getTemplateById(template?._id);


    if (type === "edit") {
      setEnableEdit(true);
    } else {
      setEnableEdit(false);
    }
  };

  const openConfirmDialog = (id, type, message, templateName) => {
    setSelectedTemplate(id);
    setConfirmOpen({
      open: true,
      type,
      message,
      isLoading: false,
    });
    if (type === "duplicate") {
      setDuplicateTemplateName(`${templateName}-Copy`);
    }
  };

  const onCloseConfirmDialog = () => {
    setConfirmOpen({
      open: false,
      type: "",
      message: "",
      isLoading: false,
    });
    setSelectedTemplate(null);
  };

  const deleteTemplateHandler = async () => {
    setConfirmOpen((prev) => {
      return {
        ...prev,
        isLoading: true,
      };
    })
    const token = await getAccessTokenSilently();
    FinanceSetting.deleteTemplateById(token, selectedTemplate)
      .then((res) => {
        toastr.success("Template deleted successfully");
        onCloseConfirmDialog();
        setRefresh(!refresh);
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message ?? "Something went wrong");
      })
      .finally(() => {
        setConfirmOpen((prev) => {
          return {
            ...prev,
            isLoading: false,
          };
        });
      });
  };

  const duplicateTemplateHandler = async () => {
    if (!duplicateTemplateName) {
      return toastr.info("Validation", "Template name is required");
    }
    setConfirmOpen((prev) => {
      return {
        ...prev,
        isLoading: true,
      };
    })
    const token = await getAccessTokenSilently();
    const data = {
      title: duplicateTemplateName,
    };
    FinanceSetting.duplicateTemplateById(token, selectedTemplate, data)
      .then((res) => {
        toastr.success("Template duplicated successfully");
        onCloseConfirmDialog();
        setRefresh(!refresh);
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message ?? "Something went wrong");
      })
      .finally(() => {
        setConfirmOpen((prev) => {
          return {
            ...prev,
            isLoading: false,
          };
        })
      });
  };

const filteredTemplates = templateList?.filter((template) => {
  if (componentCalled === "form") {
    const isBillMyAccount = template?.title?.toLowerCase().includes("bill my account");
    if (isBillMyAccount && !formik?.values?.allowBillMyAccount) return false;
    if (formik?.values?.id) return true;
    return (
      template?.title?.toLowerCase() === "form filled" ||
      template?.title?.toLowerCase() === "form filled using bill my account"
    );
  }
  if (componentCalled === "event") {
    const isBillMyAccount = template?.title?.toLowerCase().includes("bill my account");
    if (isBillMyAccount && !formik?.values?.allowBillMyAccount) return false;
    if (formik?.values?.id) return true;
    return (
      template?.title?.toLowerCase() === "event registration completed" ||
      template?.title?.toLowerCase() === "event registration using bill my account"
    );
  }
  return true;
});

  const onSortChange = (value) => {
    setPage(0);
    setSortBy(value);
  }

  return (
    <Card className={classes.card} sx={{ overflow: 'visible !important' }}>
      <Wrapper>
        <Content>
         {componentCalled!=='form' && componentCalled!=='event' && <Title>Templates</Title>}
         {componentCalled!=='form' && componentCalled!=='event' && <InfoTooltip text="Built in system templates can't be duplicated or deleted. To create your own templates, click on New Template." style={{ marginLeft: '-16px', marginRight: '16px' }} />}
   {(componentCalled==='form' || componentCalled==='event') && <div className="info_title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <h2 style={{ marginBottom: 0 }}>Team Notifications</h2>
                        <InfoTooltip text="Automated emails sent to your staff when someone registers. E.g., Notify the event coordinator or office manager each time a new registration comes in." placement="top" />
                      </div>}
         {componentCalled!=='form' && componentCalled!=='event' && <MyFilterButton
            className="campaign_filter"
            title="All"
            items={[
              { label: "Education", value: "education" },
              { label: "Event", value: "event" },
              { label: "Form", value: "form" },
              { label: "Communications", value: "communication" },
              { label: "Invitation", value: "invitation" },
              { label: "Tax Report", value: "tax_report" },
              { label: "Yahrzeits", value: "yehrzeit" },
              { label: "Invoice", value: "invoice" },
              { label: "statement", value: "tax_statement" },
              { label: "Donation", value: "donation" },
              { label: "Receipt", value: "receipt" },
              { label: "Payment Link", value: "paymentLink" },
              { label: "All", value: "all" },
            ]}
            icon={<FilterIcon style={{ width: "19px", height: "17px" }} />}
            onChange={onSortChange}

          />}
           {componentCalled!=='form' && componentCalled!=='event' && <SearchWrapper>
            <SearchComp
              value={searchValue}
              setSearchText={handleInputChange}
              placeholder="Search"
              style={{ width: "20.5rem", backgroundColor: "#fff" }}
            />
          </SearchWrapper>}
        </Content>
        {componentCalled!=='form' && componentCalled!=='event' && <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button
          variant="primary"
          onClick={() => {
            dispatch(setOpenTemplateCreationDialog(true));
          }}
          style={{
            marginRight: "1rem",
            zIndex: 20,
          }}
          size="md"
        >
          <PlusIcon />
          <span>New Template</span>
        </Button>
        </div>}
      </Wrapper>
              {(componentCalled==='form' || componentCalled==='event') &&  
               <div style={{ marginTop: "16px", fontFamily: fontConfig.CommunicationTemplatesTextFont.family,
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '40px',
            color: '#002e5c',
            margin: '0',
           }}   onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
  }}>
        
           <EmailsList
                  setSavedEmails={setSavedEmails}
                  addEmailsHandler={addEmailsHandler}
                  list={savedEmails}
                  removeEmail={removeEmailHandler}
                  placeholder={ "Enter Emails" }
                  className={"test-email-content"}

                /> 
                <hr/>
                </div> }
{(componentCalled==='form' || componentCalled==='event') && <div className="info_title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <h2 style={{ marginBottom: 0 }}>{filteredTemplates?.length>1?"Confirmation Templates":"Confirmation Template"}</h2>
                        <InfoTooltip text="The email automatically sent to attendees after they complete registration. E.g., Thank you for registering! Here are your event details, location, etc." placement="top" />
                      </div>}
      {(loading || !hasLoaded) ? (
        <NoContentWrapper style={{ height: "320px" }}>
          <Loader />
        </NoContentWrapper>
      ) : filteredTemplates?.length === 0 && !loading && hasLoaded ? (
        <NoContentWrapper>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '320px',
            gap: '12px',
          }}>
            <img
              src={NoDataIcon}
              alt="No templates"
              style={{ width: '100px', height: '100px', opacity: 0.35 }}
            />
            <p style={{
              fontFamily: fontConfig.CommunicationTemplatesTextFont.family,
              fontSize: '14px',
              fontWeight: '500',
              color: '#002E5C',
              opacity: 0.5,
              margin: 0,
            }}>
              No confirmation template available
            </p>
            <p style={{
              fontFamily: fontConfig.CommunicationTemplatesTextFont.family,
              fontSize: '12px',
              color: '#4F4F4F',
              opacity: 0.5,
              margin: 0,
            }}>
              Add a template to send confirmation emails to attendees
            </p>
          </div>
        </NoContentWrapper>
      ) : (
        <Grid container spacing={5}>
          
          {filteredTemplates?.map((value) => (
            <Grid key={value?._id} item xs={(componentCalled==='form' || componentCalled==='event')?8:6} sm={(componentCalled==='form' || componentCalled==='event')?8:6} md={(componentCalled==='form' || componentCalled==='event')?8:4} lg={(componentCalled==='form' || componentCalled==='event')?6:3} >
         {/* <input
      type="checkbox"
      checked={selectedTemplates.includes(value?._id)}
      onChange={(e) => {
            e.stopPropagation();
        handleTemplateSelect(value?._id)}}
      
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "absolute",
        top: "10px",
        left: "10px",
        zIndex: 100,
        width: "18px",
        height: "18px",
        cursor: "pointer",
      }}
    /> */}
              {/*  todo make it 6 lg and xs sm md accordingly if form */}
              <Template
                width="301.47px"
                height="257.71px"
                Content={
                  <div  style={{
      position: "relative",
      width: "100%",
      height: "100%",
    }}>
{/*     
          {componentCalled==='form'&&     <TemplateCheckbox
  id={value?._id}
  selectedTemplates={selectedTemplates}
  onSelect={handleTemplateSelect}
/>} */}

                    {value?.thumbnail && !brokenThumbnails.has(value?._id) ? (
                      <img
                        src={value?.thumbnail}
                        alt={value?.title}
                        onError={() => setBrokenThumbnails((prev) => new Set([...prev, value?._id]))}
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "block",
                          position: "relative",
                          zIndex: 1,
                        }}
                      />
                    ) : (
                      <div style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        background: "rgba(0, 46, 92, 0.03)",
                      }}>
                        <img
                          src={NoDataIcon}
                          alt="No preview"
                          style={{ width: "64px", height: "64px", opacity: 0.3 }}
                        />
                        <p style={{
                          fontFamily: fontConfig.CommunicationTemplatesTextFont.family,
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "#002E5C",
                          opacity: 0.5,
                          margin: 0,
                          textAlign: "center",
                          padding: "0 12px",
                        }}>
                          {value?.title || "Template preview not available"}
                        </p>
                      </div>
                    )}
                    <TemplateName>
                      <span>{value?.title}</span>
                    </TemplateName>
                  </div>
                  // </>

                }
                onMouseEnter={() => {
                  setIsHovered({ index: value, isHovered: true });
                }}
                onMouseLeave={() => {
                  setIsHovered({ index: null, isHovered: false });
                }}
                ButtonsContent={
                  <ButtonsContainer
                    show={
                      isHovered?.index === value ? isHovered?.isHovered : false
                    }
                  >
                    
                 { componentCalled !== 'form' && componentCalled !== 'event' &&  <MenuButton>
                      <IconButton className="p-0 px-2" onClick={() => { }}>
                        <Action
                          action="form"
                          onDuplicateClick={value?.templateSource !== "system" ? () => {
                            openConfirmDialog(value?._id, "duplicate", "Are you sure to duplicate this template ?", value?.title);
                          } : null}
                          onClassDeleteClick={() => {
                            openConfirmDialog(value?._id, "delete", "Are you sure to delete this template ?");
                          }}
                          style={{
                            // color: cardColor.color,
                            width: "16px",
                            height: "16px",
                          }}
                          checkActive={true}
                        />
                      </IconButton>
                    </MenuButton>}
                    <HoverWrapper />
                    <MyButton
                      type="secondary"
                      onClick={() => onTemplateClickHandler(value, "preview")}
                      content={"Preview"}
                      style={{
                        height: "39px",
                        opacity: 1,
                        zIndex: 1000,
                        marginRight: 20,
                        borderRadius: 5,
                      }}
                    />
                    {/* {(   componentCalled !== 'form' ||
  (componentCalled === 'form' && !value?.useDefault) )&& */}
  <MyButton
                      type="primary"
                      onClick={() => onTemplateClickHandler(value, "edit")}
                      content={"Edit"}
                      style={{
                        border: "none",
                        height: "39px",
                        opacity: 1,
                        zIndex: 1000,
                        borderRadius: 5,
                        width: 100,
                      }}
                    />
                    {/* // } */}
                  </ButtonsContainer>
                }
              />
            </Grid>
          ))}
        </Grid>
      )}
      {componentCalled!=='form' && componentCalled!=='event' && filteredTemplates?.length > 0 && (
        <div className="pagination-custom mt-9">
          <Pagination
            count={Math.ceil(count / 12)}
            color="primary"
            variant="outlined"
            page={page + 1}
            onChange={(event, value) => {
              setPage(value - 1);
            }}
          />
        </div>
      )}
      <Dialog
        open={openTempleteCreationDialog}
        onClose={() => {
          setAlertConfirmation(true);
        }}
        PaperProps={{
          style: {
            width: "1200px",
            height: "780px",
            overflow: "hidden",
            borderRadius: "22px",
            maxWidth: "1200px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <EmailEditor
          closeModal={() => {
            setAlertConfirmation(true);

          }}
          createNewTemplate={createNewTemplate}
          dropDownTypes={true}
          previewTemplete={previewTemplete}
          setHtmlContentEdit={setHtmlContent}
          setJsonContentEdit={setJsonContent}
          jsonContentEdit={
            Object.keys(formTemplateCampainPage)?.length > 0
              ? formTemplateCampainPage.jsonContent
              : jsonContent
          }
          htmlContentEdit={
            Object.keys(formTemplateCampainPage)?.length > 0
              ? formTemplateCampainPage.htmlContent
              : htmlContent
          }
          enableEdit={enableEdit}
          tokenListEdit={tokenList}
          emailEditorRef={emailEditorRef}
          templateDetails={Object.keys(formTemplateCampainPage)?.length > 0 ? formTemplateCampainPage : templateDetails}
          setEnableEdit={setEnableEdit}
          setRefresh={setRefresh}
          withSubject={enableEdit || false}
          isDuplicateEdit={componentCalled === "form" || componentCalled === "event"}
          onDuplicateEditSave={componentCalled === "event" || componentCalled === "form" ? handleDuplicateEditSave : undefined}

        />
      </Dialog>
      <AlertDialog
        open={alertConfirmation}
        onDecline={() => {
          setAlertConfirmation(false);
        }}
        onAccept={() => {
          setAlertConfirmation(false);
          dispatch(setOpenTemplateCreationDialog(false));
          dispatch(setPreviewTemplete(false));
          setEnableEdit(false);
        }}
        title={"Are you sure?"}
        description={`Do you want to discard the changes you made?`}
      />
      <AlertDialog
        open={confirmOpen.type === "delete" ? confirmOpen.open : false}
        onDecline={onCloseConfirmDialog}
        onAccept={() => {
          if (confirmOpen.type === "delete") {
            deleteTemplateHandler();
          }
        }}
        content={confirmOpen.message}
        disabled={confirmOpen.isLoading}
      />
      <MainModal
        open={confirmOpen.type === "duplicate" ? confirmOpen.open : false}
        onDecline={onCloseConfirmDialog}
        onAccept={() => {
          duplicateTemplateHandler();
        }}
        loading={confirmOpen.isLoading}
        title={"Are you sure?"}
        inputField={true}
        inputFieldLabel={"Template Name"}
        inputFieldName={"template_name"}
        inputFieldValue={duplicateTemplateName}
        onChange={(e) => {
          setDuplicateTemplateName(e.target.value);
        }}
      />
    </Card>
  );
});
